import React from "react";

import { Pill } from "src/base-components/Pill";

type SdkScriptPillProps = {
  name: string;
  iconSrc?: string;
  dataLoc?: string;
};

export const SdkScriptPill: React.FC<SdkScriptPillProps> = ({
  name,
  iconSrc,
  dataLoc,
}) => (
  <Pill
    dataLoc={dataLoc ?? "sdk-script-pill"}
    maxWidth
    size="sm"
    variant="gray"
  >
    {iconSrc && (
      <span className="flex h-4 w-4 shrink-0 items-center justify-center rounded-lg border border-gray-200 bg-white">
        <img alt="" className="h-3 w-3 object-contain" src={iconSrc} />
      </span>
    )}
    <Pill.Text>{name}</Pill.Text>
  </Pill>
);
